package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.screens.chapterComplete.model.BlanksData
import com.eladfinish.bible.contest.screens.chapterComplete.model.BlanksRecord
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.getOtiot

class ProcessRemoteBlanksUseCase {

    companion object {
        // Put unknown books at the end.
        private const val UNKNOWN_BOOK_ORDER = Int.MAX_VALUE
    }

    // Precompute: Hebrew book name -> canonical order index
    private val bookOrderByHebrew: Map<String, Int> =
        BibleCatalog.books.mapIndexed { index, book -> book.hebrew to index }.toMap()

    operator fun invoke(
        blanksData: BlanksData,
    ): Pair<List<String>, List<BlanksRecord>> {

        val sortedRecords = blanksData.values
            .sortedWith(
                comparator = compareBy(
                    { bookOrderByHebrew[it.bookHeb] ?: UNKNOWN_BOOK_ORDER },
                    { it.chapterIndex },
                    { it.createdAt }, // optional tie-breaker; remove if you don't want it
                )
            )

        val names = sortedRecords.map { record ->
            buildItemName(record)
        }

        return names to sortedRecords
    }

    private fun buildItemName(record: BlanksRecord): String {
        val authorSuffix = record.author.username
            .takeUnless { it.isNullOrEmpty() }
            ?.let { " [$it]" }
            .orEmpty()

        return buildString {
            append(record.bookHeb)
            append(" פרק ")
            append(getOtiot(record.chapterIndex).addGershaim())
            append(authorSuffix)
        }
    }
}
